package com.example.mystybag.core.helpers

import androidx.compose.runtime.mutableIntStateOf

/**
 * Web-only: incremented when app language changes so composables can use
 * [androidx.compose.runtime.key] to re-run [dev.icerock.moko.resources.compose.stringResource]
 * / shared string resolution after [com.example.mystybag.core.expected.LocaleHelper] updates Moko locale.
 */
object WebLocaleComposition {
    private val state = mutableIntStateOf(0)
    val revision: Int get() = state.intValue

    fun bump() {
        state.intValue++
    }
}
